<template>
  <el-descriptions
    :labelStyle="{ width: '100px', textAlignLast: 'justify' }"
    class="margin-v7"
    size="mini"
    :column="column"
    border
  >
    <el-descriptions-item label="姓名">
      {{ detail.patientName || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="性别">
      {{ genderMap[detail.patientGender] }}
    </el-descriptions-item>
    <el-descriptions-item label="年龄">
      {{ detail.patientAge || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="身份证号">
      {{ detail.patientNo || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="工作单位" :span="2"></el-descriptions-item>
    <el-descriptions-item label="住址">
      {{ detail.patientAddr || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="联系人">
      {{ detail.patientContactPerson || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="与患者关系">
      {{ detail.patientContactRelation || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="电话">
      <el-input
        size="mini"
        v-if="phoneEditable"
        v-model="detail.patientPhone"
      ></el-input>
      <span v-else>{{ detail.patientPhone || "--" }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="预约科室">
      {{ detail.wardName || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="科室电话">
      {{ detail.wardPhone || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="门诊诊断">
      <div v-if="detail.outDiagnosisOne">
        <b>{{ detail.outDiagnosisOne }}</b>
        <span v-if="detail.diagnosisValOne">
          ({{ detail.diagnosisValOne }})
        </span>
      </div>
      <div v-if="detail.outDiagnosisTwo">
        <b>{{ detail.outDiagnosisTwo }}</b>
        <span v-if="detail.diagnosisValTwo">
          ({{ detail.diagnosisValTwo }})
        </span>
      </div>
      <div v-if="detail.outDiagnosisThree">
        <b>{{ detail.outDiagnosisThree }}</b>
        <span v-if="detail.diagnosisValThree"
          >({{ detail.diagnosisValThree }})</span
        >
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="入院情况">
      {{ typeMap[detail.inpatientType] || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="时间">
      {{ detail.billTime || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="拟交押金"> 0.00 </el-descriptions-item>
    <el-descriptions-item label="门诊医生签名">
      {{ detail.doctorName || "--" }}
    </el-descriptions-item>
    <el-descriptions-item label="是否服从调组">
      {{ detail.obeyAdjustGroup ? "是" : "否" }}
    </el-descriptions-item>
    <el-descriptions-item label="是否服从调院区">
      {{ detail.obeyAdjustHos ? "是" : "否" }}
    </el-descriptions-item>
    <el-descriptions-item label="其他">
      <b class="color-danger" v-if="detail.inlineRemark">
        {{ detail.inlineRemark }}
      </b>
      <span v-else>--</span>
    </el-descriptions-item>
  </el-descriptions>
</template>
<script>
import { get } from "@/api/bed/record";
export default {
  props: {
    recordId: String,
    record: {
      type: Object,
      default() {
        return {};
      },
    },
    column: {
      type: Number,
      default: 1,
    },
    phoneEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detail: this.record || {},
      genderMap: {
        1: "男",
        2: "女",
      },
      typeMap: {
        danger: "危",
        urgent: "急",
        common: "一般",
      },
      typeColorMap: {
        danger: "danger",
        urgent: "waring",
        common: "primary",
      },
    };
  },
  watch:{
    record(){
      this.detail=this.record;
    }
  },
  created() {
    if (this.recordId) {
      get(this.recordId).then((res) => {
        this.detail = res.data.data;
      });
    }
  },
};
</script>
